module.exports = __webpack_public_path__ + "img/addConfidTooltip.1658a27c.svg";